import { NotificationContextProvider } from 'app/notifications';
import { CustomTestsContext } from 'pages/custom_tests/context';
import { DefaultLayout } from 'components/layout';
import { Outlet } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useApp } from 'app';

export type CustomTestPermissions = {
    CanAssign: boolean;
    CanClone: boolean;
    CanCreate: boolean;
    CanDelete: boolean;
    CanEdit: boolean;
};

export type CustomTestsContextValue = {
    permissions: CustomTestPermissions;
};

export const CustomTests = () => {

    const { highestRole } = useApp();
    const { formatMessage } = useIntl();
    const canManage = (highestRole.id ?? 0) <= 4;

    const context: CustomTestsContextValue = {
        permissions: {
            CanAssign: canManage,
            CanClone: canManage,
            CanCreate: canManage,
            CanDelete: canManage,
            CanEdit: canManage
        }
    };

    return (
        <DefaultLayout pageTitle={formatMessage({ id: 'custom_tests.9e7494ea', defaultMessage: 'Custom Tests' })}>
            <CustomTestsContext.Provider value={context}>
                <NotificationContextProvider>
                    <Outlet />
                </NotificationContextProvider>
            </CustomTestsContext.Provider>
        </DefaultLayout>
    );

};
